import { toast } from 'react-toastify';
import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FullPageLoader from '@src/common/FullPageLoader';
import { NavLink, useSearchParams, useNavigate, useParams } from 'react-router-dom';
import secureStorage from '@src/config/encrypt';
import { DocumentForm } from './DocumentForm';
import { getFormConfig, getLeadDetails, saveInsurance, updateDocumentStatus, updateFormConfig, updateInsuranceDataForAgency, uploadAndReadDocument, generateDocUrls } from '@src/store/slices/insurance';
import { addDocument, getDocumentListing, getMasterConfig, addDocumentWeb } from '@src/store/slices/common';
import VehicleDetails from './VehicleDetails';
import Plans from './Plans';
import { APP_TYPE_AGENCY, DOCUMENT_CATEGORY, INS_TYPE_CTPL, WITH_RULE_ENGINE, WITHOUT_RULE_ENGINE,EFFECTIVITY_EXPIRY_INTERVAL,BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID, STATUS_CODES, COUNTRY_CODE } from '@src/config/constant';
import { autoFillData, callServiceToCreateLead, getAddonList, isShowDynamicField } from '@common/FunctionList';
import InsuranceService from '@src/services/InsuranceService';
import AddApplicationThankPopup from './AddApplicationThankPopup';
import moment from 'moment';
import { isMobile, isBrowser } from "react-device-detect";


export default function CreateApplication(props: any) {
    const commonDataRef = useRef<any>({})
    const [page, setPage] = useState<number>(1)
    const [loading, setLoading] = useState(false)
    const [documents, setDocuments] = useState<any>({})
    const [documentErrors, setDocumentErrors] = useState<any>({})
    const [sectionList, setSectionList] = useState<any>([])
    const [refresh, setRefresh] = useState(false)
    // eslint-disable-next-line
    const [masterData, setMasterData] = useState<any>({})
    const [orcrApiCall, setOrcrApiCall] = useState<boolean>(false)
    const [documentList, setDocumentList] = useState<Array<any>>([])
    const [showThankyouPopup, setShowThankyouPopup] = useState(false)
    const [leadId, setLeadId] = useState(null)
    const [vehicleDetailsAutoFill, setVehicleDetailsAutoFill] = useState(false)
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()

    const subRoute: any = searchParams.get('step');
    const dispatch: any = useDispatch()

    const insuranceState = useSelector((state: any) => state.insurance)
    const commonState = useSelector((state: any) => state.common)

    const navigate: any = useNavigate()
    const queryParams = useParams();
    const resubmissionLeadId = queryParams.id

    const[updateMakeYear, SetUpdateMakeYear] = useState(false);

    let { user_data } = secureStorage.getItem("authAgentUserInfo") || {};

    const fetchFormConfig = async (masterData: any) => {
        const result = await dispatch(getFormConfig())
        if (result?.length) {
            updateSectionList(result, masterData)
        }
    }

    const updateSectionList = (sectionList: any, masterData: any) => {
        if (sectionList?.length) {
            let updatedList = JSON.parse(JSON.stringify(sectionList))
            updatedList.forEach((sectionItem: any) => {
                sectionItem?.blocks?.forEach((blockItem: any) => {
                    blockItem?.fields?.forEach((fieldItem: any) => {
                        if (fieldItem.name in masterData) {
                            // for make_year when motocycle is selected the populate bike_make_year as options
                            if (fieldItem.name === "make_year" && updateMakeYear) {
                                fieldItem['options'] = masterData['bike_make_year'];
                            } else if (fieldItem.name in masterData) {
                                // use make_year as options
                                fieldItem['options'] = masterData[fieldItem.name];
                            }
                        }
                    });
                });
            });
            setSectionList([...updatedList])
            dispatch(updateFormConfig(updatedList || []));
        } else {
            navigate('/create-insurance-policy?step=document_upload')
            toast.error("Error in fetching form config")
        }
    }

    const fetchDocumentList = () => {
        dispatch(getDocumentListing({
            application_type_id: 4
        })).then((res: any) => {
            if (resubmissionLeadId) {
                getResubmissionDocs(res)
            } else {
                setDocumentList(res)
                setLoading(false)
            }
        }).catch(() => {
            setLoading(false)
        })
    }

    const fetchMasterConfig = async () => {
        setLoading(true);
        if (!commonState?.common || !Object.keys(commonState?.common)?.length) {
            dispatch(getMasterConfig()).then((resp: any) => {
                if (resp.status === STATUS_CODES['success']) {
                    setMasterData(resp.data);
                    fetchFormConfig(resp.data);
                }
            });
        }
        else {
            setMasterData(commonState.common);
            fetchFormConfig(commonState.common);
        }

    }

    const checkIfORCRUploaded = async () => {
        let docs = commonDataRef.current.getData()
        if (docs?.[DOCUMENT_CATEGORY['orcr']]?.length && !orcrApiCall) {
            //call api
            await getTextFromDoc(docs[DOCUMENT_CATEGORY['orcr']])
        } else if (page < 3 && !docs?.[DOCUMENT_CATEGORY['orcr']]?.length) {
            dispatch(updateInsuranceDataForAgency({}))
        }
    }

    const getTextFromDoc = async (data: any) => {
        let formdata = new FormData()
        formdata.append('user_id', '99')

        for (let file of data) {
            formdata.append('files', file)
        }

        setLoading(true)
        //api call
        await dispatch(uploadAndReadDocument(formdata))
        setOrcrApiCall(true)
        setLoading(false)
        dispatch(saveInsurance({ ...insuranceState?.createInsurance }))
    }

    const handleNavLinkRouting = (page: number) => {
        // navigate('/create-insurance-policy?step=vehicle_details')
    }

    const validateDocuments = () => {
        let docs = commonDataRef.current.getData()
        setDocuments(docs)

        let list = documentList
        let errorOb: any = {}
        let isError = true;


        for (let ob of list) {
            if (ob.child.length && ![DOCUMENT_CATEGORY['orcr'], DOCUMENT_CATEGORY['existing_policy']].includes(ob.value)) {
                for (let childdoc of ob.child) {
                    if (childdoc.is_required && !docs?.[childdoc.value]) {
                        isError = false;
                        errorOb[childdoc.value] = `${childdoc.label} Field is required`;
                    }
                }
            }
            else if (ob.is_required && !docs?.[ob.value]) {
                isError = false;
                errorOb[ob.value] = `${ob.label} Field is required`;
            }
        }

        setDocumentErrors((prev: any) => ({ ...prev, ...errorOb }));
        return isError;
    }

    const updateAllSectionList = (type: string) => {
        let fields = commonDataRef.current.getData()
        let newSectionList: any = JSON.parse(JSON.stringify(sectionList))
        switch (type) {
            case 'vehicle_details': {
                fields = [...fields?.vehicle_details, ...fields?.customer_details]
                let insurance_type = fields?.find((e: any) => e.name === 'insurance_type')?.value?.value
                let vehicle_classification_type = fields?.find((e: any) => e.name === 'vehicle_classification')?.value?.value
                //calculate rule engine using mfg-year
                let mfgYear = fields?.find((e: any) => e.name === 'make_year')
                let diff =  [BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(+vehicle_classification_type) ? +commonState?.common?.motorcycle_rule_engine_max_year : +commonState?.common?.rule_engine_max_year
                let upperRange: any = commonState?.common?.make_year?.[0]?.value
                let lowerRange = upperRange - diff
                let ruleEngine = (lowerRange <= mfgYear?.value?.value && mfgYear?.value?.value <= upperRange) ? WITH_RULE_ENGINE : WITHOUT_RULE_ENGINE
                const vehicleDetails = newSectionList.find((item: any) => item.key === 'vehicle_details')

                let updatedList = vehicleDetails?.blocks?.map((item: any) => {
                    let newItem: any = { ...item }
                    let allFields = newItem?.fields

                    let updatedFields = allFields?.map((ele: any) => {
                        let updatedField = { ...ele }
                        let searchedItem = fields?.find((e: any) => e.name === ele.name)

                        if (searchedItem) {
                            updatedField = searchedItem
                        }
                        return updatedField
                    })
                    newItem['fields'] = updatedFields
                    return newItem
                })

                newSectionList[1].blocks = updatedList
                //for reseting addons
                // if (prevInsuranceType && prevInsuranceType !== insurance_type) {
                //     updatedFields['addon_detail'] = null
                // }

                dispatch(saveInsurance({ ...insuranceState?.createInsurance, rule_engine: ruleEngine, application_type: APP_TYPE_AGENCY, insurance_type }))
                //mark auto fill true
                // dispatch(updateInsuranceDataForAgency({ ...insuranceState?.insuranceData, autoFillVehicleDetails: true }))
                break
            }

            default: {
                break
            }
        }
        setSectionList(newSectionList)
        dispatch(updateFormConfig(newSectionList))
        return newSectionList
    }

    const isValidAddon = async (addonList: any): Promise<{ checkValue: boolean, message: Array<any> }> => {
        let flag = true;
        let message: any = []
        let { rule_engine, partner_slug } = insuranceState?.createInsurance

        if (addonList.length > 0) {
            for (let data of addonList) {
                if (data.id === 1) {
                    if (!data["coverage_amount"]) {
                        message.push("Please select coverge amount for Bodily Injured");
                        flag = false
                    }
                    if (!data["premium_amount"]) {
                        message.push("Please Enter Premium amount for Bodily Injured");
                        flag = false
                    }
                } else if (data.id === 2) {
                    if (!data["coverage_amount"]) {
                        message.push("Please select coverge amount for Property Damage");
                        flag = false
                    }
                    if (!data["premium_amount"]) {
                        message.push("Please Enter Premium amount for Property Damage");
                        flag = false
                    }
                } else if (data.id === 3) {
                    if (!data["coverage_amount"]) {
                        message.push("Please select coverge amount for Personal Accident");
                        flag = false
                    }
                    // if (rule_engine === 2 && !data["premium_amount"]) {
                    //     message.push("Please Enter Premium amount for Personal Accident");
                    //     flag = false
                    // }
                    if ((data["premium_amount"] === "" || data["premium_amount"] === undefined) && ['oona', 'milestone'].includes(partner_slug)) {
                        let premiumAmtValidation = true;
                        if (data['milestone_coverage_amount_limit'] || data['oona_coverage_amount_limit']) {
                            if (data['milestone_coverage_amount_limit'] === data['coverage_amount'] || data['oona_coverage_amount_limit'] === data['coverage_amount']) {
                                premiumAmtValidation = false;
                            }
                        }

                        if (premiumAmtValidation || rule_engine === WITHOUT_RULE_ENGINE) {

                            message.push("Please Enter Premium amount for Personal Accident");
                            flag = false
                        }
                    }

                    if (!data["seat_capacity"]) {
                        message.push("Please select seat capacity for Personal Accident");
                        flag = false
                    }
                }
            }

        }
        return new Promise((resolve) => resolve({ checkValue: flag, message }))
    }

    const validateFormDetails = () => {
        let errorFlag = true
        let fields = commonDataRef.current.getData()
        fields = subRoute === 'vehicle_details' ? [...fields?.vehicle_details, ...fields?.customer_details] : fields

        if (!fields?.length) {
            errorFlag = false
        }
        fields.forEach((ele: any) => {
            if (ele.name === 'vehicle') {
                let requiredKeys = ['make', 'model', 'version']

                ele['error_message'] = ''

                for (let key of requiredKeys) {
                    if (!((insuranceState?.createInsurance?.[key] && insuranceState?.createInsurance?.[key] !== 0) || insuranceState?.createInsurance?.[key + "_name"])) {
                        errorFlag = false
                        ele['error_message'] = ele.error_msg
                        setRefresh(!refresh)
                        break
                    }
                }

                if (!ele.value) {
                    errorFlag = false
                    ele['error_message'] = ele.error_msg
                    setRefresh(!refresh)
                }
            }
            else {

                const value = ele.value
                const fieldVisible = isShowDynamicField(ele, [{ fields }])
               
                if (fieldVisible && ele.is_required && !value) {
                    if (ele.name === 'engine_capacity' && !updateMakeYear) {

                    }else{
                        ele['error_message'] = ele.error_msg
                        errorFlag = false
                        setRefresh(!refresh)
                    }
                }

                if (['plate_number', 'mv_number'].includes(ele.name) && value) {
                    let alphanumericPattern = /^[a-z0-9]+$/i;
                    if (!alphanumericPattern.test(value)) {
                        ele['error_message'] = "Plate number should be alphanumeric"
                        errorFlag = false
                        setRefresh(!refresh)
                    }
                }

                if (ele.name === "effectivity_date" || ele.name === "expiry_date") {
                    let effectivityDate = fields.find((data: any) => data?.name === "effectivity_date")?.value;
                    let expiryDate = fields.find((data: any) => data?.name === "expiry_date")?.value;
            
                    if (!expiryDate || !effectivityDate) {
                        let missingField = !expiryDate ? 'expiry_date' : 'effectivity_date';
                        if (ele.name === missingField) {
                            ele['error_message'] = `Insurance policy ${missingField.replaceAll('_', " ")} is required`;
                            errorFlag = false;
                            setRefresh(!refresh);
                        }
                    } else {
                        let checkIfExpiryValid = moment(expiryDate).isBefore(effectivityDate);
                        let checkIfEffDateValid = moment(expiryDate).startOf('day').diff(moment(effectivityDate).startOf('day'), 'days') < 60;
                        let errorMessage = checkIfEffDateValid
                            ? `Interval between Expiry date and Effectivity date should be of ${EFFECTIVITY_EXPIRY_INTERVAL} days`
                            : null;
            
                        if (checkIfExpiryValid && ele.name === "expiry_date") {
                            ele['error_message'] = `The Expiry date cannot be earlier than the Effectivity date.`;
                            errorFlag = false;
                            setRefresh(!refresh);
                        } else if (checkIfEffDateValid && ele.name === "expiry_date") {
                            ele['error_message'] = errorMessage;
                            errorFlag = false;
                            setRefresh(!refresh);
                        }
                    }
                }
    
                if (ele.name === 'car_fmv' && ele.value) {           
                    const vehicleType = fields.find((data: any) => data?.name === "vehicle_classification")?.value?.value   
                    if ([BIKE_INS_VEHICLE_TYPE_ID, COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleType)) {
                        if (+ele.value > +ele?.validation?.bike_max_length) {
                            ele['error_message'] = `Fmv of vehicle cannot exceed ${ele?.validation?.bike_max_length}`
                            errorFlag = false;
                            setRefresh(!refresh);
                        } else if (+ele.value < +ele?.validation?.bike_min_length) { // apply minimum condition
                            ele['error_message'] = `Fmv of vehicle cannot less than ${ele?.validation?.bike_min_length}`
                            errorFlag = false
                            setRefresh(!refresh);
                        } 
                    }else if (ele.name === "car_fmv" && (value.toString().length < 6 || value.toString().length > 9)) {
                        ele['error_message'] = 'FMV of car must be between 6 to 9 digits';
                        errorFlag = false
                        setRefresh(!refresh)
                    }
                }
            }
        })

        return errorFlag
    }

    const validatePlan = (data: any) => {
        const quoteData = data
        const insurance_type = insuranceState?.createInsurance?.insurance_type
        //if validation flag is set to false then give error
        if (insurance_type !== INS_TYPE_CTPL && (!quoteData.base_issue_rate || +quoteData.base_issue_rate === 0)) {
            toast.error('Please enter valid base issue rate')
            return false
        }
        else if (!quoteData?.validation) {
            toast.error('Please select valid plan')
            return false
        }
        return true
    }

    const onsavenext = async () => {
        if (resubmissionLeadId) {
            setLoading(true);
            try {
                //code for resubmit api call
                let docs = commonDataRef.current.getData()
                let { lead_id } = insuranceState?.createInsurance
                setLeadId(lead_id);
                const docUrls: any = [];
                const comments = docs.comments;
                for (const key in docs) {
                    if (!isNaN(Number(key))) {
                        const filesOrObjects = docs[key];
                        if (Array.isArray(filesOrObjects)) {
                            for (const file of filesOrObjects) {
                                if (file instanceof File) {
                                    const formData = new FormData();
                                    formData.append('lead_id', lead_id);
                                    formData.append('files', file);

                                    // Generate URL
                                    const response: any = await generateDocUrls(formData);
                                    const uploadedFile = response[0];
                                    // Add to docUrls
                                    const fileData: any = {
                                        url: uploadedFile.file_url,
                                        document_id: Number(key),
                                    };
                                    if (comments?.[key]) {
                                        fileData["comment"] = comments[key];
                                    }
                                    docUrls.push(fileData);
                                }
                            }
                        } else if (typeof filesOrObjects === "object") {
                            // Process single objects
                            for (const subKey in filesOrObjects) {
                                const file = filesOrObjects[subKey];
                                if (file instanceof File) {
                                    const formData = new FormData();
                                    formData.append('lead_id', lead_id);
                                    formData.append('files', file);

                                    // Generate URL
                                    const response: any = await generateDocUrls(formData);
                                    const uploadedFile = response[0];

                                    // Add to docUrls
                                    const fileData: any = {
                                        url: uploadedFile.file_url,
                                        document_id: Number(key),
                                    };
                                    if (comments?.[key]) {
                                        fileData["comment"] = comments[key];
                                    }
                                    docUrls.push(fileData);
                                }
                            }
                        }
                    }
                }

                if (!docUrls?.length) return toast.error("Please select atleast 1 document to proceed")

                const requestPayload = {
                    lead_id: lead_id,
                    doc_path: docUrls,
                    is_resubmit: true,
                    created_by: user_data?.id,
                    created_by_name: user_data?.name
                };
                const addDoc: any = await addDocumentWeb(requestPayload);
                //soft delete images
                if (docs?.deletedItems?.length && addDoc.status === STATUS_CODES['success']) {
                    await updateDocumentStatus({ lead_id, documents: docs?.deletedItems })
                }
                setLoading(false);
                setShowThankyouPopup(true);
                return
            } catch (error) {
                console.error("Error during resubmission:", error);
            } finally {
                setLoading(false); // Stop loading when all operations are done
            }
        }

        //code for normal flow
        switch (subRoute) {
            case 'upload_document': {
                const validate = validateDocuments()
                if (!validate) break

                if (!resubmissionLeadId) await checkIfORCRUploaded()
                if (page < 2) setPage(2)
                navigate('/create-insurance-policy?step=vehicle_details')
                break
            }
            case 'vehicle_details': {
                const validate = validateFormDetails()
                if (!validate) break

                if (page < 3) setPage(3)
                updateAllSectionList('vehicle_details')

                dispatch(updateInsuranceDataForAgency({ ...insuranceState?.insuranceData, autoFillVehicleDetails: true }))
                navigate('/create-insurance-policy?step=premium_plan')

                break
            }
            case 'premium_plan': {
                const { addonList, quotes, partnerDetails } = commonDataRef.current.getData()
    
                let { insurance_type } = insuranceState?.createInsurance || {}
                if (!addonList?.length && !(insurance_type === INS_TYPE_CTPL && updateMakeYear)) {
                    toast.error("Please select addon to proceed")
                    break
                }

                const addons = getAddonList({ original_list: addonList }, null, insuranceState?.createInsurance?.rule_engine)
                const { checkValue, message } = await isValidAddon(addons)
                if (!checkValue) {
                    for (let msg of message) {
                        toast.error(msg);
                    }
                    break
                }

                //validate selected plan
                const noError = validatePlan(quotes)
                if (!noError) break

                submitLead(sectionList, { addon_detail: addons, ...partnerDetails, ...quotes })
                // navigate('/create-insurance-policy?step=premium_plan')
                break
            }
        }
    }

    const submitLead = async (sections: any, additionalParams?: any) => {
        setLoading(true)
        let { rule_engine,
            make, make_name, model, model_name,
            version, version_name,insurance_type,partner_slug,partner_id } = insuranceState?.createInsurance || {}
            
        let { addon_detail, base_issue_rate, net_premium, discount,referrer_mark_up } = additionalParams || {}
       
        if (!addon_detail?.length && !(insurance_type === INS_TYPE_CTPL && updateMakeYear)) {
            setLoading(false)
            return toast.error("Please select addons")
        }
        
        const params = callServiceToCreateLead(JSON.parse(JSON.stringify(sections)))
        const reqParam: any = {
            ...params,
            make, make_name,
            model, model_name,
            version, version_name,
            lead_type: 6,
            apptype: APP_TYPE_AGENCY,
            rule_engine,
            partner_id: Array.isArray(partner_id) ? partner_id[0] : partner_id,
            partner_slug: Array.isArray(partner_slug) ? partner_slug[0] : partner_slug,
            add_on_rate: base_issue_rate,
            addon_detail:addon_detail ?? [],
            tenure: params.tenure || 1,
            source: 1
        }

        // if (insuranceState?.insuranceData?.log_id) {
        //     reqParam['log_id'] = +insuranceState?.insuranceData?.log_id
        // }

        //append net_premium when net_premium is edited on plans page
        if (rule_engine === WITHOUT_RULE_ENGINE) {
            reqParam['net_premium'] = +net_premium
        }
        if(discount) {
            reqParam['discount'] = +discount
        }
        if(referrer_mark_up) {
            reqParam['referrer_mark_up'] = +referrer_mark_up
        }

        let result = await InsuranceService.createAgencyLead(reqParam)

        if (result?.data?.data?.hashId) {
            let { hashId, leadId } = result.data.data
            setLeadId(leadId)
            dispatch(updateInsuranceDataForAgency({}))
            submitDocument({ hashId })
        }
        else {
            toast.error(result.data.message)
            setLoading(false)
        }
    }

    const submitDocument = async (params: any) => {
        let { hashId } = params

        if (Object.keys(documents).length) {
            let docArray = []
            let formdata = new FormData()
            let leadId = hashId

            formdata.append('lead_id', leadId)
            formdata.append('user_id', user_data?.id)
            formdata.append('isNewCreated', "1")
            formdata.append('apptype', "" + APP_TYPE_AGENCY)

            for (let key in documents) {
                let docType = 1

                let files = documents[key]
                for (let file of files) {
                    let docObj = {
                        document_id: key,
                        type: 'add',
                        document_type_id: +docType
                    }
                    docArray.push(docObj)
                    formdata.append('files', file)
                }
            }

            formdata.append('doc_path', JSON.stringify(docArray))
            //api call
            let uploadDocument: any = await addDocument(formdata)
            //if upload successfull
            if (uploadDocument && uploadDocument.status === STATUS_CODES['success']) {
                setShowThankyouPopup(true)
                setLoading(false)
                dispatch(updateInsuranceDataForAgency({}))
                dispatch(saveInsurance({}))
            } else {
                setLoading(false)
            }
        }
    }

    const getResubmissionDocs = async (docList: any) => {
        const leadData = await dispatch(getLeadDetails({ apptype: APP_TYPE_AGENCY, leadId: resubmissionLeadId }))
        const resubmitDocs = leadData?.documents?.filter((e: any) => e?.is_resubmit)

        const keysToUpdate = ['documents', 'partner_id', 'rule_engine',
            'application_type_id', 'insurance_type', 'make', 'make_name', 'model', 'model_name',
            'version', 'version_name', 'lead_id']

        let updatedInsuranceState: any = {}
        for (let key of keysToUpdate) {
            if (leadData?.[key]) {
                if (key === 'application_type_id') {
                    updatedInsuranceState['application_type'] = leadData[key]
                } else updatedInsuranceState[key] = leadData[key]
            }
        }

        if (!resubmitDocs?.length) {
            navigate('/create-insurance-policy')
            setDocumentList(docList)
            setLoading(false)
            dispatch(saveInsurance({}))
            return
        }

        dispatch(saveInsurance({ ...insuranceState?.createInsurance, ...updatedInsuranceState }))

        let updatedDocumentList = JSON.parse(JSON.stringify(docList))

        for (let doc of updatedDocumentList) {
            let findDOc = resubmitDocs?.find((el: any) => el.id === doc?.value)
            if (findDOc) {
                doc['src'] = findDOc?.path?.map((e: any) => ({ src: e.src, id: e.id }))
                doc['is_resubmit'] = true
                doc['comment'] = findDOc?.comment
            }

            if (doc?.child?.length) {
                let child = doc.child
                for (let subDoc of child) {
                    let findSubDoc = resubmitDocs?.find((el: any) => el.id === subDoc?.value)

                    if (findSubDoc) {
                        subDoc['src'] = findSubDoc?.path?.map((e: any) => ({ src: e.src, id: e.id }))
                        subDoc['is_resubmit'] = true
                        subDoc['comment'] = findSubDoc?.comment
                    }
                }
            }
        }

        setDocumentList(updatedDocumentList)
        setLoading(false)
        setPage(4)
    }

    /**
     * for autofilling vehicle details for resubmission case 
     * @param sectionList 
     */
    const autoFillVehicleDetails = async (sectionList: any) => {
        const updatedData = await autoFillData(insuranceState?.resubmissionLeadData, sectionList?.[1])

        //update vehicle details form
        let updatedSectionList = sectionList
        updatedSectionList[1] = updatedData
        setSectionList(updatedSectionList)
        setVehicleDetailsAutoFill(true)
    }

    useEffect(() => {
        if(COUNTRY_CODE === 'id') return
        setLoading(true)
        fetchMasterConfig()
        fetchDocumentList()

        return (() => {
            dispatch(saveInsurance({}))
        })
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (!subRoute) {
            setSearchParams({ step: 'upload_document' })
        }
        //eslint-disable-next-line
    }, [subRoute])

    /**
     * for handling auto fill of vehicle details in resubmission case 
     */
    useEffect(() => {
        const resubData = insuranceState?.resubmissionLeadData
        if (resubmissionLeadId && resubData && Object.keys(resubData)?.length && sectionList?.length && !vehicleDetailsAutoFill) {
            autoFillVehicleDetails(sectionList)
        }

        //eslint-disable-next-line
    }, [resubmissionLeadId, insuranceState?.resubmissionLeadData, sectionList])

    
    return (
        <>
            <FullPageLoader show={loading} />
            <div className="container-fluid add-insurnce-outer">
                <div className="top-heading financer-lead-heding">
                    <h1>Create Application</h1> 
                </div>
                <div className="lead-detail-tabs">
                    {
                        sectionList && <div className="detail-form-sec">
                            <div className="menu-tab-left-panel">
                                <div className="dealer-tab-left-panel nav">
                                    <ul>
                                        {
                                            sectionList.map((sectionItem: any, index: any) => {
                                                return (
                                                    <li key={index}>
                                                        {
                                                            ((page > index)) ?
                                                                <NavLink to={`/create-insurance-policy${resubmissionLeadId ? ('/' + resubmissionLeadId) : ''}?step=` + sectionItem['key']} onClick={(e) => { handleNavLinkRouting(index + 1) }} className={(index + 1) < page ? "completed" : ""} >
                                                                    <span className="img-type">
                                                                        {isMobile && (index+1) }
                                                                    </span>
                                                                    {sectionItem['title']}</NavLink>
                                                                :
                                                                <a href="#!" onClick={(e) => e.preventDefault()}>
                                                                    <span className="img-type">
                                                                        {isMobile && (index+1) }
                                                                    </span>
                                                                    {sectionItem['title']}
                                                                </a>

                                                        }
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>

                            <div className="route-files">
                                <div className=" insurance-create-outer relative " style={{ "display": "block" }}>
                                    <div className="loan-expect-left-panle">
                                        <div className="loan-form">
                                            <div className={`loan-form-filed-scroll ${(searchParams?.get('step') === 'upload_document') ? `quote-scroll` : ''}`}>
                                                {
                                                    subRoute === "upload_document"
                                                    && <div className="loan-filed-sec">
                                                        <div className="row">
                                                            <div className="col-md-12 w-100">
                                                                <h2>Upload Documents</h2>
                                                            </div>
                                                            <DocumentForm ref={commonDataRef} docList={documentList} setDocuments={setDocuments} errors={documentErrors} documents={documents} updateDocList={(params: any) => setDocumentList(params)} setDocumentErrors={setDocumentErrors} setOrcrApiCall={setOrcrApiCall} resubmissionLeadId={resubmissionLeadId} />
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    subRoute === 'vehicle_details'
                                                    && <VehicleDetails ref={commonDataRef} setLoading={setLoading} documents={documents} setPage={setPage} resubmissionLeadId={resubmissionLeadId} setSectionList={setSectionList} SetUpdateMakeYear={SetUpdateMakeYear}/>
                                                }
                                                {
                                                    subRoute === 'premium_plan'
                                                    && <Plans ref={commonDataRef} setLoading={setLoading} sectionList={sectionList} sectionItem={sectionList?.[2]} setPage={setPage} resubmissionLeadId={resubmissionLeadId} />
                                                }
                                                {

                                                    <div className="btn-continue btn-bottom-fixed">

                                                        {
                                                            ((resubmissionLeadId && subRoute === 'upload_document')
                                                                || !resubmissionLeadId)
                                                            &&
                                                            <button className="btn-primary " onClick={() => { onsavenext() }}>{
                                                                resubmissionLeadId ? 'Resubmit Docs' : 'Save & Continue'
                                                            }</button>
                                                        }

                                                    </div>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            {
                showThankyouPopup && <AddApplicationThankPopup show={showThankyouPopup} handleClose={() => {
                    setShowThankyouPopup(false)
                    navigate(`/insurance-list`)
                }} leadId={leadId} />
            }
        </>
    )
}